<template>
  <div class="search-bar">
    <div class="search-bar__wrapper">
      <div class="search-bar__input-wrap">
        <input
          v-model="keyword"
          class="search-bar__input"
          type="text"
          placeholder="搜索时政/报道/文章"
          @keyup.enter="onSearch"
        />
      </div>
      <div class="search-bar__btn" @click="onSearch(keyword)">
        <img
          class="search-bar__icon"
          src="../assets/img/icon-search.png"
          alt="search"
        />
        <span>搜索</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  data() {
    return {
      keyword: ''
    }
  },
  methods: {
    onSearch(val) {
      console.log('搜索:', val)
      this.$emit('search', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar {
  padding: 12px 16px;
  margin-top: 14px;
  &__wrapper {
    display: flex;
    align-items: center;
    width: 245px;
    height: 32px;
    border-radius: 16px;
    overflow: hidden;
    background: #FFFFFF;
    border: 1px solid #3C73E2;
  }

  &__input-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }

  &__input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 12px;
    color: #333;
    background: transparent;

    &::placeholder {
      color: #999;
    }
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 12px;
    background: linear-gradient(135deg, #4a90e2, #357abd);
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    flex-shrink: 0;

    span {
      margin-left: 4px;
      white-space: nowrap;
    }
  }

  &__icon {
    width: 14px;
    height: 14px;
  }
}
</style>
